import React, { useState, useEffect } from "react";
import Wrapper from "./wrapper";
import { getTagMetrics } from "../../services/tag";
import { getSession } from "../../services/auth";
import Loader from "../misc/loader";
// Assets
import audiences from "../../assets/svgs/audiences.svg";
import processor from "../../assets/svgs/processor.svg";
import info from "../../assets/svgs/info.svg";
import { Tooltip } from "react-tooltip";

function Metrics() {
	const [tagId, setTagId] = useState(localStorage.getItem("activeSilo"));
	const [publisherSettings, setPublisherSettings] = useState(localStorage.getItem("publisherSettings"));
	const [metrics, setMetrics] = useState();
	const [loading, setLoading] = useState(true);
	const [modelingEnabled, setModelingEnabled] = useState(false);
	const [amsFlavor, setAmsFlavor] = useState("");
	const [modelLimit, setModelLimit] = useState("");

	const verifyAccess = async () => {
		const session = getSession();
		if (!session) return;

		const settings = await JSON.parse(publisherSettings) ?? {};
		let modelingEnabledValue = settings.modeling_enabled ?? false;
		let amsFlavorValue = settings.ams_flavor ?? "full";
		setModelingEnabled(modelingEnabledValue);
		setAmsFlavor(amsFlavorValue);
		setModelLimit(settings.modelLimit);
		if (tagId) {
			await getTagMetrics(tagId, amsFlavorValue, modelingEnabledValue).then((_metrics) => {
				setMetrics(_metrics.data);
				setLoading(_metrics == null);
			});
		}
	};

	useEffect(() => {
		window.addEventListener("storage", () => {
			setTagId(localStorage.getItem("activeSilo"));
			setPublisherSettings(localStorage.getItem("publisherSettings"));
		});
	}, []);

	useEffect(() => {
		verifyAccess();
	}, [tagId, publisherSettings]);

	const formatNumber = (num) => {
		const formatter = Intl.NumberFormat("en-Us", { notation: "compact" });
		return formatter.format(num);
	};

	return (
		<>
			<Wrapper
				heading={
					<span>
						<span className="strong">
							{!loading ? formatNumber(metrics.allTime.totalAudiences) : ""}
						</span>{" "}
						Total Audiences
					</span>
				}
				icon={audiences}
				link={{ to: "/audience-manager", text: "View All" }}
				padded={true}
			>
				{loading ? (
					<Loader size="xl" />
				) : (
					<>
						<p className="p3">
							<span className="strong">{formatNumber(metrics.allTime.customAudiences)}</span> Total
							Custom
						</p>
						<p className="p3">
							<span className="strong">{formatNumber(metrics.allTime.autoGeneratedAudiences)}</span>{" "}
							Total Auto-Generated
						</p>
						{(amsFlavor === "full" && modelingEnabled) && (
							<div className="total-audiences-row">
								<p className="p3">
									<span className="strong">{formatNumber(metrics.allTime.modeledAudiences)}</span>{" "}
									Total Modeled
								</p>
								<Tooltip id={`metrics`} />
								<div
									className="info-img-box"
									data-tooltip-id={`metrics`}
									data-tooltip-content={`Your account is limited to ${modelLimit} active models.`}
								>
									<img
										src={info}
										alt="Info"
									/>
								</div>
							</div>
						)}
					</>
				)}
			</Wrapper>
			<Wrapper
				heading={"ArcSpan Processor"}
				subheading="Last 30 Days"
				icon={processor}
				padded={true}
			>
				{loading ? (
					<Loader size="xl" />
				) : (
					<>
						{amsFlavor === "full" && (
						<p className="p3">
							<span className="strong">{formatNumber(metrics.last30days.urlsProcessed)}</span> URLs
						</p>
						)}
						<p className="p3">
							<span className="strong">{formatNumber(metrics.last30days.uniqueUsers)}</span> Unique
							Users
						</p>
					</>
				)}
			</Wrapper>
		</>
	);
}

export default Metrics;
